import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuth } from '@/shared/hooks/useAuth';
import { useOrgStore } from '@/shared/stores/orgStore';
import { ROUTES } from '@/shared/config/routes';

/**
 * ProtectedRoute — guards authenticated routes.
 * - Not authenticated → redirect to login
 * - Authenticated but onboarding not completed → redirect to onboarding
 *   (unless already on onboarding route)
 */
export function ProtectedRoute() {
  const { isAuthenticated } = useAuth();
  const organization = useOrgStore((s) => s.organization);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.AUTH.LOGIN} replace />;
  }

  // Check onboarding completion
  const isOnboardingRoute = location.pathname.startsWith(ROUTES.ONBOARDING.ROOT);
  if (organization && !organization.onboarding_completed && !isOnboardingRoute) {
    return <Navigate to={ROUTES.ONBOARDING.ROOT} replace />;
  }

  return <Outlet />;
}
